'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFilterTiltShift = function MdFilterTiltShift(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm9.5 32.9l2.3-2.4q2.9 2.2 6.6 2.7v3.4q-5-0.5-8.9-3.7z m12.1 0.3q3.7-0.5 6.5-2.7l2.4 2.4q-3.9 3.2-8.9 3.7v-3.4z m8.9-5q2.2-3 2.7-6.5h3.4q-0.5 4.9-3.7 8.8z m-5.5-8.2q0 2-1.5 3.5t-3.5 1.5-3.5-1.5-1.5-3.5 1.5-3.5 3.5-1.5 3.5 1.5 1.5 3.5z m-18.2 1.6q0.5 3.7 2.7 6.5l-2.4 2.5q-3.2-4-3.7-9h3.4z m2.7-9.8q-2.2 2.9-2.7 6.6h-3.4q0.5-5 3.7-8.9z m23.7 6.6q-0.5-3.7-2.7-6.6l2.4-2.3q3.2 3.9 3.7 8.9h-3.4z m-2.7-11.3l-2.3 2.4q-2.9-2.2-6.6-2.7v-3.4q5 0.5 8.9 3.7z m-12.1-0.3q-3.7 0.5-6.6 2.7l-2.3-2.4q3.9-3.2 8.9-3.7v3.4z' })
        )
    );
};

exports.default = MdFilterTiltShift;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/filter-tilt-shift.js
// module id = 1461
// module chunks = 168707334958949